import { takeEvery, call, put } from 'redux-saga/effects';
import { gcApi } from '../config/axios';
import {
    CREATE_EPOCH_DATA_RELOAD,
    CREATE_EPOCH_DATA_RELOAD_FETCHING,
    CREATE_EPOCH_DATA_RELOAD_SUCCESS,
    CREATE_EPOCH_DATA_RELOAD_FAIL
} from '../actions/ActionTypes';

// Workers
export function* requestEpochDataReload(action) {
    const { calendarDate, deviceId } = action;

    try {
        yield put({
            type: CREATE_EPOCH_DATA_RELOAD_FETCHING
        });

        let url = `/wellness-service/wellness/epoch/request/${calendarDate}`;

        if (deviceId) {
            url += `/${deviceId}`;
        }

        const response = yield call(gcApi.post, url);

        yield put({
            type: CREATE_EPOCH_DATA_RELOAD_SUCCESS,
            calendarDate: calendarDate,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: CREATE_EPOCH_DATA_RELOAD_FAIL,
            calendarDate: calendarDate,
            data: null
        });
    }
}

// Watcher
export const epochDataReloadSagas = [takeEvery(CREATE_EPOCH_DATA_RELOAD, requestEpochDataReload)];
